//#region imports
import React from 'react';
import Container from '@mui/material/Container';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { FEEDBACK_URL, OFERTA_URL } from 'configs/constants';
import { Typography } from '@mui/material';
import useMobile from 'hooks/useMobile';
//#endregion

interface IProps {
  className?: string;
  termsHref?: string;
  termsLabel?: string;
  feedbackHref?: string;
  feedbackLabel?: string;
}

const Footer: React.FC<IProps> = ({
  className,
  termsLabel,
  termsHref = OFERTA_URL,
  feedbackHref = FEEDBACK_URL,
  feedbackLabel
}) => {
  const { t } = useTranslation();
  const classes = styles();
  const { isMobile } = useMobile();

  return (
    <footer className={ cn(className, classes.root) }>
      <Container className={ classes.container }>
        <Typography variant="inherit"> { t('footer.company') } </Typography>
        <div className={ classes.links }>
          <a className={ classes.link } href={ feedbackHref } target="_blank" rel="noreferrer">
            { feedbackLabel ?? t('footer.feedback') }
          </a>
          <a className={ classes.link } href={ termsHref } target="_blank" rel="noreferrer">
            { termsLabel ?? t('footer.terms') }
          </a>
        </div>
        <Typography variant="inherit"> { t('footer.socialHeader') } { !isMobile && t('footer.socialDesc') }</Typography>
        { isMobile &&
          <Typography variant="inherit"> { t('footer.socialDesc') } </Typography>
        }
      </Container>
    </footer>

  );
};

export default Footer;
